module.exports = require("core-js-pure/features/instance/sort");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/instance/sort.js
// module id = 482
// module chunks = 13